module.exports = __webpack_public_path__ + "img/collection-weddingRingsExclusive@2x.0776a3f.webp";